/**
 * General custom scripts
 */

/**
 * Set header height
 */

import { setHeaderHeightVar } from './front/components/dynamic-header-height';


setHeaderHeightVar()

/**
 * Video Lightbox
 */
import { videoLightbox } from './front/components/video-lightbox';


videoLightbox();

/**
 * Calendly Popup
 */
import { calendlyPopup } from './front/components/calendly-popup';


calendlyPopup();

/**
 * Header
 */
import { megaMenuPositions, mobileMenu } from './front/header';


megaMenuPositions();
mobileMenu();

/**
 * Footer
 */
import { footerMenu } from './front/footer';


footerMenu();


